import React from "react";
import { Badge, Layout } from "antd";
import { Switch, Route, Redirect } from "react-router-dom";
import Sidebar from "../../../components/Backoffice/Sidebar";
import Topbar from "../../../components/Backoffice/Topbar";
import AuthorisedFor from "../../../utils/authorisedFor";
import * as ACTIONS from "../../../constants/actions";
import logoSvg from './logo.svg'
import CompanyListing from "./CompanyListing";
import MasterCatalog from "./MasterCatalog";
import AddCompany from "./AddCompany";
import UserSummaryListing from "./UserSummaryListing";
import CompanyUserListing from "./CompanyUserListing";
import OrderListing from "./OrderListing";
import LabPartnerListing from "./LabPartnerListing";
import LogisticsPartnerListing from "./LogisticsPartnerListing";
import AddUser from "./AddUser";
import AddTest from "./AddTest";
import AddLabPartner from "./AddLabPartner";
import AddLogisticsPartner from "./AddLogisticsPartner";
import CompanyCatalogListing from "./CompanyCatalogListing";
import CompanyCatalog from "./CompanyCatalog";
import EditCompanyCatalog from "./EditCompanyCatalog";
import CompanyCatalogAdd from "./CompanyCatalogAdd";
import routes from "../../../../routes";
import ViewCompany from "./ViewCompany";
import UserView from "./UserView";
import UserEdit from "./UserEdit";
import CompanyEdit from "./CompanyEdit";
import OrderDetails from "./OrderDetails";
import PackageList from "./PackageList";
import PackageAdd from "./PackageAdd";
import PackageDetails from "./PackageDetails";
//import PackageEdit from "./PackageEdit";
import BookTest from "./BookTest";
import PaymentReminder from "./PaymentReminder";
import { useAuth } from "../../../contexts/auth";
import ViewLabPartner from "./ViewLabPartner";
import EditLabPartner from "./EditLabPartners";
import ViewLogisticsPartner from "./ViewLogisticsPartner";
import EditLogisticPartner from "./EditLogisticPartners";
import ServiceRequest from "./ServiceRequest";
import AddressSummaryListing from "./AddressSummaryLIsting";
import CompanyBillingAddressListing from "./CompanyBillingAddressesListing";
import CompanyPickupAddressListing from "./CompanyPickupAddressListing";
import ViewAnalytics from "./ViewAnalytics";
import SamplerListing from "./SamplerListing";
import AgencyListing from "./AgencyListing";
import SamplerEdit from "./SamplerEdit";
import AssetManagement from "./AssetManagement";
import DashboardNew from "./DashboardNew";
import DetailsRouter from "./DetailsRouter";
import AssetDetails from "./AssetDetails";
import ReportsPage from "./Report";

const { backOffice } = routes;
const { Content, Sider } = Layout;

const BackOffice = () => {
  const auth = useAuth();
  const isCompanyAdmin = auth.isCompanyAdmin;

  const homeRedirect = isCompanyAdmin
    ? backOffice.orders.list
    : backOffice.dashboard;

  return (
    <Layout>
      <Sider style={styles.sider} width={250}>
        <div style={styles.siderLogoContainer}>
              <img src={logoSvg} alt="Logo" style={{ height: '32px', width: 'auto' }} />

          {/*    <Badge offset={[5, 4]} count={"beta"} /> */}
        </div>
        <Sidebar />
      </Sider>

      <Layout style={{ marginLeft: 250 }}>
        <Topbar />
        <Content style={styles.content}>
          <Switch>
            <Route exact path={backOffice.dashboard}>
              <Redirect to={backOffice.companies.list} />
            </Route>
            <Route exact path={backOffice.companies.list}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_COMPANY_LISTING}
                yes={<CompanyListing />}
                // no={<Redirect to={homeRedirect} />}
                no={"Access Restricted"}
              />
            </Route>
            <Route exact path={backOffice.companies.new}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_ADD_NEW_COMPANY}
                yes={<AddCompany />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            {/* <Route exact path={backOffice.analytics.view}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_ANALYTICS}
                yes={<ViewAnalytics />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route> */}
            <Route exact path={backOffice.companies.details.view}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_VIEW_COMPANY}
                yes={<ViewCompany />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.companies.details.edit}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_EDIT_COMPANY}
                yes={<CompanyEdit />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>

            <Route
              exact
              path={backOffice.companies.details.billingAddresses.list}
            >
              <AuthorisedFor
                action={ACTIONS.ACCESS_COMPANY_BILLINGADDRESSES_LISTING}
                yes={<CompanyBillingAddressListing />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route
              exact
              path={backOffice.companies.details.pickupAddresses.list}
            >
              <AuthorisedFor
                action={ACTIONS.ACCESS_COMPANY_PICKUPADDRESSES_LISTING}
                yes={<CompanyPickupAddressListing />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.companies.details.users.list}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_COMPANY_USER_LISTING}
                yes={<CompanyUserListing />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.companies.details.users.new}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_ADD_USER}
                yes={<AddUser />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.companies.details.users.view}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_VIEW_USER_DETAILS}
                yes={<UserView />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.companies.details.users.edit}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_EDIT_USER}
                yes={<UserEdit />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.companies.details.catalog.list}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_COMPANY_CATALOG}
                yes={<CompanyCatalog />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.companies.details.catalog.edit}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_EDIT_COMPANY_CATALOG}
                yes={<EditCompanyCatalog />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.companies.details.catalog.add}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_ADD_COMPANY_CATALOG}
                yes={<CompanyCatalogAdd />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.users}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_USER_SUMMARY}
                yes={<UserSummaryListing />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.addresses}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_ADDRESS_SUMMARY}
                yes={<AddressSummaryListing />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.addresses}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_ADDRESS_SUMMARY}
                yes={<AddressSummaryListing />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.addresses}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_ADDRESS_SUMMARY}
                yes={<AddressSummaryListing />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.orders.list}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_ORDER_LISTING}
                yes={<OrderListing />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.orders.payments}>
              <AuthorisedFor
                action={ACTIONS.BO_ACCESS_PAYMENT_REMINDER}
                yes={<PaymentReminder />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.orders.new}>
              <AuthorisedFor
                action={ACTIONS.BO_ACCESS_BOOK_TEST}
                yes={<BookTest />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.orders.details.view}>
              <AuthorisedFor
                action={ACTIONS.BO_ACCESS_ORDER_DETAILS}
                yes={<OrderDetails />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.orders.details.serviceRequest}>
              <AuthorisedFor
                action={ACTIONS.BO_ACCESS_ORDER_DETAILS}
                yes={<ServiceRequest />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.catalog.master}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_MASTER_CATALOG}
                yes={<MasterCatalog />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.catalog.companies}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_COMPANY_CATALOG_LISTING}
                yes={<CompanyCatalogListing />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.catalog.tests.new}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_ADD_TEST}
                yes={<AddTest />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.labPartners.list}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_LAB_LISTING}
                yes={<LabPartnerListing />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.labPartners.new}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_ADD_LAB}
                yes={<AddLabPartner />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.labPartners.details.view}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_VIEW_LAB}
                yes={<ViewLabPartner />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.labPartners.details.edit}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_EDIT_LAB}
                yes={<EditLabPartner />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.logisticPartners.list}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_LOGISTICS_LISTING}
                yes={<LogisticsPartnerListing />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.logisticPartners.new}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_ADD_LOGISTICS}
                yes={<AddLogisticsPartner />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.logisticPartners.details.view}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_LOGISTICS_LISTING}
                yes={<ViewLogisticsPartner />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.logisticPartners.details.edit}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_LOGISTICS_LISTING}
                yes={<EditLogisticPartner />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.packages.list}>
              <AuthorisedFor
                action={ACTIONS.BO_ACCESS_PACKAGE_LISTING}
                yes={<PackageList />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.packages.add}>
              <AuthorisedFor
                action={ACTIONS.BO_ADD_PACKAGE}
                yes={<PackageAdd />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.packages.details.view}>
              <AuthorisedFor
                action={ACTIONS.BO_ACCESS_PACAKGE_DETAILS}
                yes={<PackageDetails />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            {/*  <Route exact path={backOffice.packages.details.edit}>
              <AuthorisedFor
                action={ACTIONS.BO_EDIT_PACKAGE}
                yes={<PackageEdit />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route> */}

            <Route exact path={backOffice.samplers.list}>
              <AuthorisedFor
                // Need to assign proper sampler listing here
                action={ACTIONS.BO_ACCESS_SAMPLER_LISTING}
                yes={<SamplerListing />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.samplers.details.edit}>
              <AuthorisedFor
                // Need to assign proper sampler listing here
                action={ACTIONS.ACCESS_ORDER_LISTING}
                yes={<SamplerEdit />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.agencies.list}>
              <AuthorisedFor
                action={ACTIONS.ACCESS_ORDER_LISTING}
                yes={<AgencyListing />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.assets.list}>
              <AuthorisedFor
                action={ACTIONS.BO_ACCESS_ASSETS_LISTING}
                yes={<AssetManagement />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.assets.details.view}>
              <AuthorisedFor
                action={ACTIONS.BO_ACCESS_ASSETS_DETAIL_VIEW}
                yes={<AssetDetails />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.dashboard_new.view}>
              <AuthorisedFor
                action={ACTIONS.BO_DASHBOARD_NEW}
                yes={<DashboardNew />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.dashboard_new.details}>
              <AuthorisedFor
                action={ACTIONS.BO_DASHBOARD_NEW} 
                yes={<DetailsRouter />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
            <Route exact path={backOffice.dashboard_new.report}>
              <AuthorisedFor
                action={ACTIONS.BO_DASHBOARD_NEW_REPORT} 
                yes={<ReportsPage />}
                no={<Redirect to={homeRedirect} />}
              />
            </Route>
          </Switch>
        </Content>
      </Layout>
    </Layout>
  );
};

const styles = {
  sider: {
    overflow: "auto",
    height: "100vh",
    position: "fixed",
    left: 0,
  },
  siderLogoContainer: {
    height: 28,
    margin: 16,
    display: "flex",
    alignItems: "center",
  },
  logoText: { color: "#fff", marginBottom: 0, fontSize: "1.5rem" },
  content: {
    margin: "0",
    overflowY: "auto",
    height: "calc(100vh - 64px)",
  },
};

export default BackOffice;
